import React from "react";
import { lifestylePhotos } from "../data/offer";
export function ConnectionSection() {
  return <section className="bg-paper" data-id="element-32" data-mp="386iofb3o6mye">
      <div className="mx-auto grid max-w-6xl items-center gap-10 px-5 py-16 md:py-24 lg:grid-cols-[0.9fr_1.1fr] lg:gap-16" data-id="element-33" data-mp="385ps742c7fui">
        <img src={lifestylePhotos.readingTogether} alt="Une maman lit une histoire à sa fille, blotties sur le canapé" className="aspect-[4/5] w-full max-w-md rounded-[2rem] object-cover lg:max-w-none" data-id="element-34" data-mp="2tfigd76u4v2s" />
        <div data-id="element-35" data-mp="2oii8qruc7k9k">
          <h2 className="font-display text-3xl font-semibold leading-tight text-ink md:text-[2.6rem]" data-id="element-36" data-mp="2oj1ihl9u32ci">
            Vous aimeriez transmettre votre foi à vos enfants… mais vous ne
            savez pas toujours comment vous y prendre ?
          </h2>
          <div className="mt-6 space-y-4 text-base leading-relaxed text-ink-soft md:text-lg" data-id="element-37" data-mp="8r46uyf86p3b">
            <p data-id="element-38" data-mp="8pav54pr9eog">
              Entre l’école, les repas, les devoirs et le coucher, les journées
              passent vite. Et même lorsque l’on souhaite parler de Dieu à ses
              enfants, il n’est pas toujours facile de trouver les bons mots ou
              le bon moment.
            </p>
            <p data-id="element-39" data-mp="e0g01lhrowl9">
              Pourtant, ce sont parfois les instants les plus simples — une
              histoire lue ensemble, une question posée avec douceur, une petite
              prière — qui ouvrent les plus belles conversations.
            </p>
          </div>
          <p className="mt-8 border-l-4 border-terracotta pl-5 font-display text-xl italic leading-snug text-ink md:text-2xl" data-id="element-40" data-mp="3iexo7n1ub8qf">
            Vous n’avez pas besoin d’être théologien ni de préparer de longues
            leçons pour commencer.
          </p>
        </div>
      </div>
    </section>;
}